export const getPaginatedAttendants = (state) =>
  Object.values(state?.attendants?.pagination?.byUuid ?? {})

export const getAttendantByUuid = (state, uuid) =>
  state?.attendants?.pagination?.byUuid?.[uuid] ?? {}

export const getIsLoadingAttendants = (state) =>
  state?.attendants?.isLoading ?? false

export const getTotalAttendantsCount = (state) =>
  state?.attendants?.pagination?.total ?? 0
